export enum queryFilters {
  text = 'text'
}
